import React, { useState } from "react";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const AdminKeyGate = ({ onSubmit, error, loading }) => {
  const [key, setKey] = useState("");
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <form
        onSubmit={(e) => { e.preventDefault(); onSubmit(key); }}
        className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl p-8 shadow-sm"
        data-testid="admin-key-form"
      >
        <div className="w-11 h-11 rounded-xl bg-green-600 flex items-center justify-center mb-5">
          <Lock className="w-5 h-5 text-white" />
        </div>
        <h1 className="text-xl font-bold text-slate-900">Leads & verdicts</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">Espace privé. Entrez votre clé admin.</p>
        <Input type="password" value={key} onChange={(e) => setKey(e.target.value)} placeholder="Clé admin" autoFocus data-testid="admin-key-input" />
        {error && <p className="text-sm text-red-600 mt-3" data-testid="admin-key-error">{error}</p>}
        <Button type="submit" disabled={!key || loading} className="w-full mt-4 bg-green-600 hover:bg-green-700" data-testid="admin-key-submit">
          {loading ? "Vérification…" : "Ouvrir"}
        </Button>
      </form>
    </div>
  );
};
